import { Api } from 'utils';

class AccessoryService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/accessories/get',params),
		getServices: async (params?: any) => Api.createResponse('admin/accessories/services',params),
		create: async (params?: any) => Api.createResponse('admin/accessories/create',params),
		update: async (params?: any) => Api.createResponse('admin/accessories/update',params),
		delete: async (params?: any) => Api.createResponse('admin/accessories/delete',params),
	}

}

export default AccessoryService;